import React, { useEffect, useRef, useState } from "react";
import FaExpandAni from "./FaExpandAni";
import RoughBorder from "../../kits/LayoutKit/RoughBorder";

export default function ModalWrapper({ children, onClose }) {
  const modalRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile on mount
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  // Scroll lock und scroll to top
  useEffect(() => {
    const prev = document.body.style.overflow;

    // Sofort nach oben scrollen
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    // Kurze Verzögerung, dann overflow sperren
    const timer = setTimeout(() => {
      document.body.style.overflow = "hidden";
    }, 100);

    // Hide BitterButtonWithMenu by adding a class to body
    document.body.classList.add('modal-open');

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = prev;
      document.body.classList.remove('modal-open');
    };
  }, []);

  const handleBackdropClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) onClose?.();
  };

  // Mobile Version - Fullscreen Overlay (wie SearchOverlay)
  if (isMobile) {
    return (
      <div
        role="dialog"
        aria-modal="true"
        style={{ zIndex: 999999 }}
        className="fixed top-0 left-0 right-0 bottom-0 bg-white backdrop-blur-2xl overflow-y-auto overscroll-contain"
      >
        <div className="w-full min-h-screen flex flex-col">
          <button
            type="button"
            onClick={onClose}
            className="sticky top-4 z-10 ml-auto mr-6"
            aria-label="Schließen"
          >
            <FaExpandAni />
          </button>

          <div className="flex-1 pt-8 pb-6 px-6">
            {children}
          </div>
        </div>
      </div>
    );
  }

  // Desktop Version - Fullscreen Overlay
  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{ zIndex: 999999 }}
      className="fixed top-0 left-0 right-0 bottom-0 bg-slate-50 overflow-y-auto overscroll-contain"
    >
      <div className="w-full min-h-screen flex flex-col items-center">
        <button
          type="button"
          onClick={onClose}
          className="sticky top-6 z-10 ml-auto mr-20"
          aria-label="Schließen"
        >
          <FaExpandAni />
        </button>

        <div className="w-full max-w-4xl flex-1 pt-12 pb-8 px-8">
          <div ref={modalRef} className="relative">
            {children}
            <RoughBorder
              parentRef={modalRef}
              radius={20}
              padding={2}
              color="#AC8E66"
              strokeWidth={0.3}
              roughness={1}
              bowing={2}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
